module.exports = __webpack_public_path__ + "img/symbol_8.7d93ff5b.png";